import React, { FC, useState } from 'react'
import { IAssetsHook } from '../hooks/useAssets'
import { LinkButton, IconButton, Popover, Icon } from '@ui'
import { Menu, MenuItem } from '@blueprintjs/core'
import ImportFlow from '../../ImportFlow'
import useImport, { Import } from '../../ImportFlow/hooks/useImport'
import { useFileDownload } from '@hooks'

type MoreActionsPropsT = {
  assetsHook: IAssetsHook
}

const MoreActions: FC<React.PropsWithChildren<MoreActionsPropsT>> = ({ assetsHook }) => {
  const startFileDownload = useFileDownload()
  const [isEmployeeAssetImportingOpen, setisEmployeeAssetImportingOpen] = useState(false)
  const [isSpaceAssetImportingOpen, setisSpaceAssetImportingOpen] = useState(false)
  const importEmployeeAssets = useImport(Import.EMPLOYEE_ASSETS)
  const importSpaceAssets = useImport(Import.SPACE_ASSETS)

  return (
    <>
      <Popover
        content={
          <Menu>
            <MenuItem
              text="Import Assets to Employees"
              icon={<Icon style={{ marginTop: 2 }} name="file-import" />}
              onClick={() => setisEmployeeAssetImportingOpen(true)}
            />
            <MenuItem
              text="Import Assets to Spaces"
              icon={<Icon style={{ marginTop: 2 }} name="file-import" />}
              onClick={() => setisSpaceAssetImportingOpen(true)}
            />
            <MenuItem
              text="Download CSV"
              icon={<Icon style={{ marginTop: 2, width: 22 }} name="download" />}
              onClick={() => assetsHook.fetchExportLink().then((url) => startFileDownload(url))}
            />
          </Menu>
        }
      >
        <IconButton round={false} className="ml2" tooltip="More actions" iconName="ellipsis-h" />
      </Popover>
      {isEmployeeAssetImportingOpen && (
        <ImportFlow
          title="Import Assets to Employees"
          importHook={importEmployeeAssets}
          onClose={() => setisEmployeeAssetImportingOpen(false)}
          excludeUpdated
          onComplete={() => assetsHook.reload()}
        >
          <>
            <p>
              <LinkButton onClick={assetsHook.fetchTemplate} text="Download the .csv template" />{' '}
              for bulk operation asset import
            </p>
            <ul>
              <li>
                You can import multiple assets, or a single asset. Multiple assets can be imported
                in the same row (separated by ; / semicolon) for any Employee.
              </li>
              <li>New data will merge with existing data.</li>
            </ul>
          </>
        </ImportFlow>
      )}
      {isSpaceAssetImportingOpen && (
        <ImportFlow
          title="Import Assets to Spaces"
          importHook={importSpaceAssets}
          onClose={() => setisSpaceAssetImportingOpen(false)}
          excludeUpdated
          onComplete={() => assetsHook.reload()}
        >
          <>
            <p>
              <LinkButton
                onClick={assetsHook.fetchSpacesTemplate}
                text="Download the .csv template"
              />{' '}
              for bulk operation asset import
            </p>
            <ul>
              <li>
                You can import multiple assets, or a single asset. Multiple assets can be imported
                in the same row (separated by ; / semicolon) for any space.
              </li>
              <li>New data will merge with existing data.</li>
            </ul>
          </>
        </ImportFlow>
      )}
    </>
  )
}

export default MoreActions
